module.exports = __webpack_public_path__ + "img/GAME_JANGGI.ee9f5026.png";